var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-plotly',{ref:"borderCrossingsChart",attrs:{"data":_vm.crossingsData,"layout":_vm.crossingsLayout,"options":{displayModeBar: false}}})}
var staticRenderFns = []

export { render, staticRenderFns }